import { Component } from '@angular/core';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-careers-values-section',
  templateUrl: './careers-values-section.component.html',
  styleUrls: ['./careers-values-section.component.scss'],
  standalone: true,
  imports: [TuiIcon],
})
export class CareersValuesSectionComponent {}
